module.exports = __webpack_public_path__ + "img/euflag.1d437774.1d437774.png";